(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dietxp-calculator-hub-v2"] && !Shopify.designMode) return;
  try {
    
(function () {
  var root = document.getElementById('dxcalc-root');
  if (!root) return;

  var form = root.querySelector('#dxcalc-search-form');
  var input = root.querySelector('#dxcalc-search-input');
  var clear = root.querySelector('#dxcalc-search-clear');
  var featured = root.querySelector('#dxcalc-featured');
  var catalogue = root.querySelector('#dxcalc-catalogue');
  var resultSection = root.querySelector('#dxcalc-search-results');
  var resultGrid = root.querySelector('#dxcalc-search-grid');
  var resultStatus = root.querySelector('#dxcalc-search-status');
  var resultExplanation = root.querySelector('#dxcalc-search-explanation');
  var empty = root.querySelector('#dxcalc-search-empty');
  var categoryRail = root.querySelector('#dxcalc-category-list');
  var categorySelect = root.querySelector('#dxcalc-category-select');
  var announcement = root.querySelector('#dxcalc-announcement');
  var quickSearch = root.querySelector('#dxcalc-quick-search');
  var categoryButtons = Array.prototype.slice.call(root.querySelectorAll('[data-category-filter]'));
  var categorySections = Array.prototype.slice.call(root.querySelectorAll('[data-directory-section]'));
  var cards = Array.prototype.slice.call(root.querySelectorAll('[data-catalog-card]'));
  var goalButtons = Array.prototype.slice.call(root.querySelectorAll('[data-goal-search]'));
  var activeCategory = 'all';
  var motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
  var reducedMotion = motionQuery.matches;
  function onMotionPreferenceChange(event) {
    reducedMotion = event.matches;
  }
  if (motionQuery.addEventListener) motionQuery.addEventListener('change', onMotionPreferenceChange);
  else motionQuery.addListener(onMotionPreferenceChange);

  var railControllers = Array.prototype.slice.call(root.querySelectorAll('[data-calculator-rail]')).map(function (rail) {
    var controls = root.querySelector('[data-rail-controls="' + rail.id + '"]');
    var arrows = Array.prototype.slice.call(controls.querySelectorAll('button'));
    var position = controls.querySelector('.dxcalc-rail-position');
    var scheduled = false;

    function sync() {
      scheduled = false;
      var railCards = rail.querySelectorAll('.dxcalc-card');
      var count = railCards.length;
      var max = Math.max(0, rail.scrollWidth - rail.clientWidth);
      var canScroll = rail.clientWidth > 0 && max > 2;
      controls.hidden = !canScroll;
      if (canScroll) rail.setAttribute('tabindex', '0');
      else rail.removeAttribute('tabindex');
      arrows[0].disabled = rail.scrollLeft <= 2;
      arrows[1].disabled = rail.scrollLeft >= max - 2;
      if (!count || !rail.clientWidth) return;
      var gap = parseFloat(window.getComputedStyle(rail).columnGap) || 0;
      var step = railCards[0].getBoundingClientRect().width + gap;
      var first = Math.max(1, Math.min(count, Math.round(rail.scrollLeft / step) + 1));
      var last = Math.max(first, Math.min(count, Math.floor((rail.scrollLeft + rail.clientWidth + gap) / step)));
      var label = first === last ? first + ' of ' + count : first + ' to ' + last + ' of ' + count;
      if (position.textContent !== label) position.textContent = label;
    }

    function scheduleSync() {
      if (!scheduled) {
        scheduled = true;
        window.requestAnimationFrame(sync);
      }
    }

    function move(direction) {
      var firstCard = rail.querySelector('.dxcalc-card');
      if (!firstCard) return;
      var step = firstCard.getBoundingClientRect().width + (parseFloat(window.getComputedStyle(rail).columnGap) || 0);
      rail.scrollBy({ left: direction * step, behavior: reducedMotion ? 'auto' : 'smooth' });
    }

    arrows.forEach(function (button) {
      button.addEventListener('click', function () {
        move(Number(button.getAttribute('data-rail-direction')));
      });
    });
    rail.addEventListener('keydown', function (event) {
      if (event.target !== rail) return;
      if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
        event.preventDefault();
        move(event.key === 'ArrowRight' ? 1 : -1);
      } else if (event.key === 'Home' || event.key === 'End') {
        event.preventDefault();
        rail.scrollTo({ left: event.key === 'Home' ? 0 : rail.scrollWidth, behavior: reducedMotion ? 'auto' : 'smooth' });
      }
    });
    rail.addEventListener('focusin', function (event) {
      var card = event.target.closest('.dxcalc-card');
      if (!card) return;
      var frame = rail.getBoundingClientRect();
      var cardFrame = card.getBoundingClientRect();
      if (cardFrame.left < frame.left || cardFrame.right > frame.right) {
        rail.scrollTo({ left: rail.scrollLeft + cardFrame.left - frame.left - 3, behavior: 'auto' });
      }
    });
    rail.addEventListener('scroll', scheduleSync, { passive: true });
    window.addEventListener('resize', scheduleSync, { passive: true });
    if (window.ResizeObserver) new ResizeObserver(scheduleSync).observe(rail);
    return { sync: sync };
  });

  function syncRails() {
    railControllers.forEach(function (controller) { controller.sync(); });
  }

  function scrollToSection(node) {
    node.scrollIntoView({ block: 'start', behavior: reducedMotion ? 'auto' : 'smooth' });
  }

  function normalise(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, ' ')
      .trim();
  }

  function searchScore(card, query) {
    var title = normalise(card.getAttribute('data-title'));
    var tags = normalise(card.getAttribute('data-tags'));
    var words = query.split(' ').filter(Boolean);
    var score = 0;

    words.forEach(function (word) {
      if (title === word) score += 120;
      else if (title.indexOf(word) === 0) score += 70;
      else if (title.indexOf(word) !== -1) score += 45;
      if (tags.indexOf(word) !== -1) score += 16;
    });

    return score;
  }

  function updateHeaderOffset() {
    var selectors = [
      'header.header-section',
      '.shopify-section-header-sticky',
      '.header-wrapper',
      '#shopify-section-header',
      '.header-mobile'
    ];
    var height = 0;
    selectors.forEach(function (selector) {
      var node = document.querySelector(selector);
      if (!node) return;
      var rect = node.getBoundingClientRect();
      var style = window.getComputedStyle(node);
      var isSticky = style.position === 'sticky' || style.position === 'fixed';
      if (rect.height > 0 && (isSticky || rect.top <= 1)) {
        var topOffset = isSticky ? Math.min(0, parseFloat(style.top) || 0) : 0;
        height = Math.max(height, rect.height + topOffset);
      }
    });
    root.style.setProperty('--dxcalc-header-offset', Math.round(height) + 'px');
  }

  function updateUrl(query) {
    if (!window.history || !window.URL) return;
    var url = new URL(window.location.href);
    if (query) url.searchParams.set('q', query);
    else url.searchParams.delete('q');
    if (activeCategory !== 'all' && !query) url.searchParams.set('cat', activeCategory);
    else url.searchParams.delete('cat');
    window.history.replaceState({}, '', url.pathname + url.search + url.hash);
  }

  function setActiveCategory(category, moveFocus) {
    activeCategory = category;
    root.setAttribute('data-category', category);
    categorySelect.value = category;
    var selectedButton = null;
    categoryButtons.forEach(function (button) {
      var selected = button.getAttribute('data-category-filter') === category;
      button.setAttribute('aria-pressed', selected ? 'true' : 'false');
      if (selected) {
        selectedButton = button;
        if (moveFocus) button.focus({ preventScroll: true });
      }
    });

    if (selectedButton && category !== 'all' && categoryRail.scrollWidth > categoryRail.clientWidth) {
      categoryRail.scrollTo({
        left: selectedButton.offsetLeft - (categoryRail.clientWidth - selectedButton.offsetWidth) / 2,
        behavior: reducedMotion ? 'auto' : 'smooth'
      });
    }

    categorySections.forEach(function (section) {
      var sectionCategory = section.getAttribute('data-directory-section');
      section.hidden = category === 'all' ? sectionCategory === 'smart' : sectionCategory !== category;
    });

    if (input.value.trim()) input.value = '';
    clear.hidden = true;
    resultSection.hidden = true;
    featured.hidden = category !== 'all';
    catalogue.hidden = false;
    announcement.textContent = category === 'all' ? 'All 64 calculators are available.' : categorySelect.options[categorySelect.selectedIndex].text + ' selected.';
    updateUrl('');
    syncRails();
  }

  function runSearch(rawQuery, sourceLabel) {
    var query = normalise(rawQuery);
    resultGrid.innerHTML = '';
    clear.hidden = !query;

    if (!query) {
      resultSection.hidden = true;
      featured.hidden = activeCategory !== 'all';
      catalogue.hidden = false;
      updateUrl('');
      syncRails();
      return;
    }

    if (activeCategory !== 'all') {
      setActiveCategory('all', false);
      input.value = rawQuery;
      clear.hidden = false;
    }

    var ranked = cards
      .map(function (card) {
        return { card: card, score: searchScore(card, query) };
      })
      .filter(function (item) {
        return item.score > 0;
      })
      .sort(function (a, b) {
        if (b.score !== a.score) return b.score - a.score;
        return a.card.getAttribute('data-title').localeCompare(b.card.getAttribute('data-title'));
      });

    ranked.forEach(function (item) {
      var clone = item.card.cloneNode(true);
      clone.removeAttribute('data-catalog-card');
      resultGrid.appendChild(clone);
    });

    resultStatus.textContent = ranked.length + (ranked.length === 1 ? ' tool' : ' tools');
    announcement.textContent = resultStatus.textContent + ' found for ' + rawQuery.trim() + '.';
    resultExplanation.textContent = sourceLabel || 'Closest matches for "' + rawQuery.trim() + '".';
    empty.hidden = ranked.length !== 0;
    resultSection.hidden = false;
    featured.hidden = true;
    catalogue.hidden = true;
    resultGrid.scrollLeft = 0;
    updateUrl(rawQuery.trim());
    syncRails();
  }

  categoryButtons.forEach(function (button) {
    button.addEventListener('click', function () {
      setActiveCategory(button.getAttribute('data-category-filter'), false);
      scrollToSection(root.querySelector('#dxcalc-directory'));
    });

    button.addEventListener('keydown', function (event) {
      if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
      event.preventDefault();
      var currentIndex = categoryButtons.indexOf(button);
      var nextIndex = currentIndex;
      if (event.key === 'ArrowLeft') nextIndex = Math.max(0, currentIndex - 1);
      if (event.key === 'ArrowRight') nextIndex = Math.min(categoryButtons.length - 1, currentIndex + 1);
      if (event.key === 'Home') nextIndex = 0;
      if (event.key === 'End') nextIndex = categoryButtons.length - 1;
      categoryButtons[nextIndex].click();
      categoryButtons[nextIndex].focus({ preventScroll: true });
    });
  });

  goalButtons.forEach(function (button) {
    button.addEventListener('click', function () {
      var query = button.getAttribute('data-goal-search');
      input.value = query;
      setActiveCategory('all', false);
      input.value = query;
      runSearch(query, 'A practical starting set for this goal.');
      var goalPanel = root.querySelector('.dxcalc-mobile-goals');
      if (goalPanel) goalPanel.open = false;
      root.querySelector('#dxcalc-search-heading').focus({ preventScroll: true });
      scrollToSection(resultSection);
    });
  });

  categorySelect.addEventListener('change', function () {
    setActiveCategory(categorySelect.value, false);
    scrollToSection(root.querySelector('#dxcalc-directory'));
  });

  quickSearch.addEventListener('click', function () {
    input.focus({ preventScroll: true });
    form.scrollIntoView({ block: 'center', behavior: reducedMotion ? 'auto' : 'smooth' });
  });

  form.addEventListener('submit', function (event) {
    event.preventDefault();
    runSearch(input.value);
    if (input.value.trim()) {
      root.querySelector('#dxcalc-search-heading').focus({ preventScroll: true });
      scrollToSection(resultSection);
    }
  });

  input.addEventListener('input', function () {
    runSearch(input.value);
  });

  clear.addEventListener('click', function () {
    input.value = '';
    runSearch('');
    input.focus();
  });

  document.addEventListener('keydown', function (event) {
    if ((event.metaKey || event.ctrlKey) && event.key.toLowerCase() === 'k') {
      event.preventDefault();
      input.focus();
    }
    if (event.key === 'Escape' && document.activeElement === input && input.value) {
      input.value = '';
      runSearch('');
    }
  });

  var params = new URLSearchParams(window.location.search);
  var initialQuery = params.get('q');
  var initialCategory = params.get('cat');
  setActiveCategory('all', false);
  if (initialQuery) {
    input.value = initialQuery;
    runSearch(initialQuery);
  } else if (initialCategory && categoryButtons.some(function (button) {
    return button.getAttribute('data-category-filter') === initialCategory;
  })) {
    setActiveCategory(initialCategory, false);
  }

  updateHeaderOffset();
  window.addEventListener('resize', updateHeaderOffset, { passive: true });
  window.addEventListener('load', updateHeaderOffset, { once: true });
  if (window.ResizeObserver) {
    var observedHeader = document.querySelector('header.header-section') || document.querySelector('#shopify-section-header') || document.querySelector('.header-wrapper');
    if (observedHeader) new ResizeObserver(updateHeaderOffset).observe(observedHeader);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dietxp-calculator-strip"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('dietxp-calculator-cards')) {
  customElements.define('dietxp-calculator-cards', class extends HTMLElement {
    connectedCallback() {
      this.rail = this.querySelector('.dx-calculator-cards__rail');
      this.cards = Array.from(this.querySelectorAll('.dx-calculator-cards__item'));
      this.controls = this.querySelector('.dx-calculator-cards__controls');
      if (!this.rail || !this.cards.length || !this.controls) return;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.previous = this.querySelector('[data-direction="-1"]');
      this.next = this.querySelector('[data-direction="1"]');
      this.position = this.querySelector('.dx-calculator-cards__position');
      this.controls.hidden = false;
      this.controls.addEventListener('click', event => {
        const button = event.target.closest('button[data-direction]');
        if (button && !button.disabled) this.move(Number(button.dataset.direction));
      }, options);
      this.rail.addEventListener('scroll', () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.update());
      }, { ...options, passive: true });
      this.rail.addEventListener('keydown', event => {
        if (event.target !== this.rail) return;
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault();
          this.move(event.key === 'ArrowRight' ? 1 : -1);
        }
      }, options);
      this.rail.addEventListener('focusin', event => {
        const card = event.target.closest('.dx-calculator-cards__item');
        if (card) {
          this.rail.scrollTo({ left: card.offsetLeft - this.cards[0].offsetLeft, behavior: 'instant' });
        }
      }, options);
      this.resize = new ResizeObserver(() => this.update());
      this.resize.observe(this.rail);
      this.update();
    }
    move(direction) {
      const step = this.cards.length > 1
        ? this.cards[1].offsetLeft - this.cards[0].offsetLeft
        : this.rail.clientWidth;
      this.rail.scrollBy({
        left: direction * step,
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
      });
    }
    update() {
      const max = this.rail.scrollWidth - this.rail.clientWidth;
      const left = this.rail.scrollLeft;
      this.previous.disabled = left <= 2;
      this.next.disabled = left >= max - 2;
      const edge = this.rail.getBoundingClientRect().left;
      let current = this.cards.findIndex(card => card.getBoundingClientRect().right > edge + 12);
      if (current < 0) current = this.cards.length - 1;
      const label = (current + 1) + ' / ' + this.cards.length;
      if (this.position.textContent !== label) this.position.textContent = label;
    }
    disconnectedCallback() {
      if (this.abort) this.abort.abort();
      if (this.resize) this.resize.disconnect();
      cancelAnimationFrame(this.frame);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dietxp-product-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dietxp-product-hero')) {
    customElements.define('dietxp-product-hero', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.dx-hero__track');
        this.slides = [...this.querySelectorAll('.dx-hero__slide')];
        this.dots = [...this.querySelectorAll('[data-slide]')];
        this.pauseButton = this.querySelector('[data-pause]');
        this.browse = this.querySelector('.dx-hero__browse');
        this.counter = this.querySelector('[data-counter]');
        this.status = this.querySelector('.dx-hero__status');
        if (!this.track || this.slides.length < 2) return;
        this.controller = new AbortController();
        const listen = (node, event, handler) => node.addEventListener(event, handler, { signal: this.controller.signal });
        this.index = 0;
        this.paused = false;
        this.hovered = false;
        this.dragging = false;
        this.inView = false;
        this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
        this.mobile = matchMedia('(max-width: 767px)');
        listen(this, 'click', (event) => {
          const button = event.target.closest('button');
          if (!button) return;
          if (button.hasAttribute('data-slide')) {
            this.paused = true;
            this.browse.open = false;
            this.browse.querySelector('summary').focus({ preventScroll: true });
            this.go(Number(button.dataset.slide), 'instant', true);
          }
          if (button.hasAttribute('data-direction')) this.go(this.index + Number(button.dataset.direction), undefined, true);
          if (button.hasAttribute('data-pause')) { this.paused = !this.paused; this.syncPlayback(); }
        });
        listen(this.browse, 'toggle', () => this.syncPlayback());
        listen(this, 'keydown', (event) => {
          if (event.key === 'Escape' && this.browse.open) {
            this.browse.open = false;
            this.browse.querySelector('summary').focus({ preventScroll: true });
          }
        });
        listen(document, 'click', (event) => { if (!this.browse.contains(event.target)) this.browse.open = false; });
        listen(this.track, 'scrollend', () => { if (this.userDragged) { this.announce(); this.userDragged = false; } });
        listen(this.track, 'scroll', () => {
          cancelAnimationFrame(this.scrollFrame);
          this.scrollFrame = requestAnimationFrame(() => {
            const anchor = this.track.getBoundingClientRect().left + (this.mobile.matches ? 16 : this.track.clientWidth / 2);
            let nearest = 0;
            this.slides.forEach((slide, i) => {
              const rect = slide.getBoundingClientRect();
              const current = this.slides[nearest].getBoundingClientRect();
              const position = this.mobile.matches ? rect.left : rect.left + rect.width / 2;
              const currentPosition = this.mobile.matches ? current.left : current.left + current.width / 2;
              if (Math.abs(position - anchor) < Math.abs(currentPosition - anchor)) nearest = i;
            });
            this.activate(nearest);
          });
        });
        listen(this.track, 'keydown', (event) => {
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
            event.preventDefault();
            this.go(this.index + (event.key === 'ArrowRight' ? 1 : -1), undefined, true);
          }
        });
        listen(this, 'pointerenter', (event) => { if (event.pointerType === 'mouse') { this.hovered = true; this.syncPlayback(); } });
        listen(this, 'pointerleave', () => { this.hovered = false; this.syncPlayback(); });
        listen(this.track, 'pointerdown', () => { this.dragging = true; this.dragStart = this.track.scrollLeft; this.userDragged = true; this.syncPlayback(); });
        const release = () => { if (this.dragging) { this.dragging = false; this.userDragged = Math.abs(this.track.scrollLeft - this.dragStart) > 2; this.syncPlayback(); } };
        listen(window, 'pointerup', release);
        listen(window, 'pointercancel', release);
        listen(this, 'focusin', (event) => {
          const slide = event.target.closest('.dx-hero__slide');
          if (slide) this.go(this.slides.indexOf(slide), 'instant');
          this.syncPlayback();
        });
        listen(this, 'focusout', () => queueMicrotask(() => this.isConnected && this.syncPlayback()));
        listen(document, 'visibilitychange', () => this.syncPlayback());
        listen(this.reduced, 'change', () => this.syncPlayback());
        listen(this.mobile, 'change', () => this.go(this.index, 'instant'));
        listen(document, 'shopify:block:select', (event) => {
          const i = this.slides.findIndex(slide => slide.dataset.blockId === event.detail.blockId);
          if (i >= 0) { this.paused = true; this.go(i, 'instant'); }
        });
        this.observer = new IntersectionObserver(([entry]) => { this.inView = entry.isIntersecting; this.syncPlayback(); }, { threshold: .25 });
        this.observer.observe(this);
        this.resizeObserver = new ResizeObserver(() => this.go(this.index, 'instant'));
        this.resizeObserver.observe(this.track);
        this.activate(0);
        this.syncPlayback();
      }
      activate(index) {
        this.index = index;
        if (this.counter) this.counter.textContent = String(index + 1).padStart(2, '0');
        this.dots.forEach((dot, i) => Number(dot.dataset.slide) === index ? dot.setAttribute('aria-current', 'true') : dot.removeAttribute('aria-current'));
        const images = [...this.slides[index].querySelectorAll('img')];
        images.forEach(image => { image.loading = 'eager'; });
        const next = () => {
          if (this.index !== index) return;
          const image = this.slides[(index + 1) % this.slides.length].querySelector('.dx-hero__picture img');
          if (image) image.loading = 'eager';
        };
        if (images[0]?.complete) next();
        else if (images[0] && !images[0].dataset.nextBound) {
          images[0].dataset.nextBound = 'true';
          images[0].addEventListener('load', next, { once: true, signal: this.controller.signal });
        }
      }
      announce() {
        if (this.status) this.status.textContent = this.slides[this.index].getAttribute('aria-label') + ': ' + this.slides[this.index].dataset.label;
      }
      go(index, behavior, announce = false) {
        index = (index + this.slides.length) % this.slides.length;
        const target = this.slides[index].getBoundingClientRect();
        const viewport = this.track.getBoundingClientRect();
        const inset = this.mobile.matches ? 16 : (this.track.clientWidth - target.width) / 2;
        this.track.scrollTo({ left: this.track.scrollLeft + target.left - viewport.left - inset, behavior: behavior || (this.reduced.matches ? 'instant' : 'smooth') });
        this.activate(index);
        if (announce) this.announce();
        this.syncPlayback();
      }
      syncPlayback() {
        clearTimeout(this.timer);
        const stopped = this.paused || this.reduced.matches;
        if (this.pauseButton) {
          this.pauseButton.setAttribute('aria-label', stopped ? this.pauseButton.dataset.playLabel : this.pauseButton.dataset.pauseLabel);
          this.pauseButton.firstElementChild.textContent = stopped ? '▶' : 'Ⅱ';
          this.pauseButton.hidden = this.reduced.matches;
        }
        if (this.dataset.autoplay !== 'true' || stopped || this.browse.open || this.hovered || this.dragging || !this.inView || document.hidden || this.contains(document.activeElement)) return;
        this.timer = setTimeout(() => this.go(this.index + 1), Number(this.dataset.interval) || 6000);
      }
      disconnectedCallback() {
        clearTimeout(this.timer);
        cancelAnimationFrame(this.scrollFrame);
        this.controller?.abort();
        this.observer?.disconnect();
        this.resizeObserver?.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dxp-ecosystem-ticker"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dxp-ecosystem-ticker')) {
    customElements.define('dxp-ecosystem-ticker', class extends HTMLElement {
      connectedCallback() {
        this.viewport = this.querySelector('.dxp-ticker__viewport');
        this.group = this.querySelector('.dxp-ticker__group');
        this.toggle = this.querySelector('.dxp-ticker__toggle');
        if (!this.viewport || !this.group || !this.toggle) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        const syncButton = () => {
          const paused = this.dataset.paused === 'true';
          this.toggle.setAttribute('aria-pressed', String(paused));
          this.toggle.setAttribute('aria-label', paused ? this.toggle.dataset.playLabel : this.toggle.dataset.pauseLabel);
        };
        this.toggle.addEventListener('click', () => {
          this.dataset.paused = String(this.dataset.paused !== 'true');
          syncButton();
        }, options);
        this.viewport.addEventListener('focusin', (event) => {
          event.target.closest('a')?.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'instant' });
        }, options);
        this.viewport.addEventListener('focusout', () => {
          requestAnimationFrame(() => {
            if (this.isConnected && !this.viewport.contains(document.activeElement)) this.viewport.scrollLeft = 0;
          });
        }, options);
        this.observer = new ResizeObserver(() => {
          const duration = Math.max(Number(this.dataset.duration) || 45, this.group.getBoundingClientRect().width / 65);
          this.style.setProperty('--dxp-ticker-duration', `${duration}s`);
        });
        this.observer.observe(this.group);
        syncButton();
        this.classList.add('is-ready');
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header_mobile"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function syncDisclosure(details) {
      var summary = details.querySelector(':scope > summary');
      if (summary) summary.setAttribute('aria-expanded', details.open ? 'true' : 'false');
    }

    function syncHomepageSocials(drawer) {
      var socialSection = drawer.querySelector('[data-dx-mm-socials]');
      var socialLinks = drawer.querySelector('[data-dx-mm-social-links]');
      var homepageSocials = document.querySelector('.dx-footer-social');
      if (!socialSection || !socialLinks || !homepageSocials) return;

      var sourceLinks = homepageSocials.querySelectorAll('a[href]');
      if (!sourceLinks.length) return;

      socialLinks.replaceChildren();
      sourceLinks.forEach(function (sourceLink) {
        var socialLink = sourceLink.cloneNode(true);
        socialLink.classList.add('dx-mm-social-icon');
        socialLinks.appendChild(socialLink);
      });
      socialSection.hidden = false;
    }

    function bindDrawer(drawer) {
      syncHomepageSocials(drawer);
      if (drawer.getAttribute('data-dx-commerce-menu-bound') === 'true') return;
      drawer.setAttribute('data-dx-commerce-menu-bound', 'true');

      var nrgtToggle = drawer.querySelector('[data-dx-mm-nrgt-toggle]');
      var nrgtPanel = drawer.querySelector('[data-dx-mm-nrgt-panel]');
      var nrgtAction = drawer.querySelector('[data-dx-mm-nrgt-action]');

      if (nrgtToggle && nrgtPanel) {
        nrgtToggle.addEventListener('click', function () {
          var shouldOpen = nrgtToggle.getAttribute('aria-expanded') !== 'true';
          nrgtToggle.setAttribute('aria-expanded', shouldOpen ? 'true' : 'false');
          nrgtPanel.hidden = !shouldOpen;
          if (nrgtAction) nrgtAction.textContent = shouldOpen ? 'Hide flavours' : 'Choose a flavour';
        });
      }

      drawer.querySelectorAll('[data-dx-mm-disclosure]').forEach(function (details) {
        syncDisclosure(details);
        details.addEventListener('toggle', function () {
          syncDisclosure(details);
        });
      });
    }

    function initDrawers(root) {
      var scope = root && root.querySelectorAll ? root : document;
      scope.querySelectorAll('#Drawer-Menu.dx-mobile-menu-commerce').forEach(bindDrawer);
      if (scope.matches && scope.matches('#Drawer-Menu.dx-mobile-menu-commerce')) bindDrawer(scope);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initDrawers(document);
      });
    } else {
      initDrawers(document);
    }

    document.addEventListener('shopify:section:load', function () {
      initDrawers(document);
    });
  }());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-product-tabs"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__productTabsSectionBound) return;
    window.__productTabsSectionBound = true;

    function renderVideo(scope) {
      const root = scope || document;
      root.querySelectorAll('.video-open-popup:not([data-video-bound])').forEach((videoOpenPopup) => {
        videoOpenPopup.dataset.videoBound = 'true';
        videoOpenPopup.addEventListener('click', function (e) {
          e.preventDefault();
          const videoId = videoOpenPopup.dataset.videoId;
          const videoWrapper = document.querySelector('.video-modal__content-block');
          if (!videoWrapper || !videoId) return;
          videoWrapper.innerHTML = `<iframe width="100%" src="https://www.youtube.com/embed/${videoId}?si=6yJ56P_BJEG5d2Uq" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>`;
        });
      });
    }

    function ensureVideoModal() {
      if (document.getElementById('PopupModal-product-tabs-video')) return;
      document.body.insertAdjacentHTML(
        'beforeend',
        `<side-drawer class="popup__content video-modal drawer fixed top-0 left-0 z-9 w-screen h-full flex justify-center no-js-hidden" id="PopupModal-product-tabs-video" data-moved="true">
          <div class="drawer__overlay fixed inset-0 cursor-pointer"></div>
          <div class="popup__inner color-scheme-1 popup__inner--video w-auto h-full absolute-c-c flex flex-column global-settings-popup">
            <div class="popup__inner--content relative w-full h-full overflow-auto cus-scrollbar">
              <div class="video-modal__content-block">Video</div>
              <button onclick="this.closest('side-drawer').close()" class="button button-unstyled close-button popup__close minimum-touch-target-before drawer__close block t-button bor-none rounded-full cursor-pointer absolute" type="button" aria-label="Close dialog" style="--top: 0.3rem; --right: 0.3rem">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" class="icon icon-close" viewBox="0 0 18 17"><path fill="currentColor" d="M.865 15.978a.5.5 0 0 0 .707.707l7.433-7.431 7.579 7.282a.501.501 0 0 0 .846-.37.5.5 0 0 0-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 1 0-.707-.708L8.991 7.853 1.413.573a.5.5 0 1 0-.693.72l7.563 7.268z"></path></svg>
              </button>
            </div>
          </div>
        </side-drawer>`
      );
    }

    function openAccordionTab(tabContent) {
      const section = tabContent.closest('.section-product-tabs');
      if (!section) return;
      section.querySelectorAll('.style-accordion .toggle-title.is-open').forEach((el) => el.classList.remove('is-open'));
      tabContent.querySelector('.toggle-title')?.classList.add('is-open');
    }

    function closeAccordionTab(tabContent) {
      tabContent.querySelector('.toggle-title')?.classList.remove('is-open');
    }

    document.addEventListener('click', function (e) {
      const section = e.target.closest('.section-product-tabs');
      if (!section) return;

      const tabTitle = e.target.closest('.tab-title');
      if (tabTitle && section.contains(tabTitle)) {
        e.preventDefault();
        const tabList = section.querySelector('.tabs-list');
        if (!tabList) return;
        const tabTitles = [...tabList.querySelectorAll('.tab-title')];
        const tabContents = [...section.querySelectorAll('.product-tabs-tab .tabs-content > .tab-content')];
        const index = tabTitles.indexOf(tabTitle);
        if (index === -1 || tabTitle.classList.contains('is-active')) return;
        tabTitles.forEach((t) => t.classList.remove('is-active'));
        tabContents.forEach((c) => c.classList.remove('is-active'));
        tabTitle.classList.add('is-active');
        setTimeout(() => {
          const content = tabContents[index];
          if (!content) return;
          content.classList.add('is-animating', 'is-active');
          content.addEventListener(
            'transitionend',
            function handler() {
              content.classList.remove('is-animating');
              content.removeEventListener('transitionend', handler);
            },
            { once: true }
          );
        }, 10);
        return;
      }

      const toggleLink = e.target.closest('.toggle-link');
      if (!toggleLink || !section.contains(toggleLink)) return;
      e.preventDefault();

      const toggleTitle = toggleLink.closest('.toggle-title');
      if (!toggleTitle) return;

      const tabTitleText = document.querySelector('.tab-title-text');
      if (tabTitleText) tabTitleText.textContent = toggleLink.textContent;

      const viewContentType = toggleTitle.dataset.viewContent;
      const content = toggleTitle.nextElementSibling;
      if (!content) return;

      if (Shopify?.designMode && section.querySelector('.style-accordion')) return;

      switch (viewContentType) {
        case 'sidebar': {
          const drawerContent = document.querySelector('#Global-Drawer .drawer__wrapper');
          if (drawerContent) {
            drawerContent.innerHTML = '';
            drawerContent.appendChild(content.cloneNode(true));
            renderVideo(drawerContent);
          }
          break;
        }
        case 'popup': {
          const popupContent = document.querySelector('.popup-content-wrapper');
          if (popupContent) {
            popupContent.innerHTML = '';
            popupContent.appendChild(content.cloneNode(true));
            renderVideo(popupContent);
          }
          break;
        }
        default:
          toggleTitle.classList.toggle('is-open');
      }
    });

    if (Shopify?.designMode) {
      document.addEventListener('shopify:block:select', function (e) {
        const tabContent = e.target.closest('.section-product-tabs .tab-content');
        if (!tabContent) return;
        openAccordionTab(tabContent);
      });

      document.addEventListener('shopify:block:deselect', function (e) {
        const tabContent = e.target.closest('.section-product-tabs .tab-content');
        if (!tabContent) return;
        closeAccordionTab(tabContent);
      });
    }

    document.addEventListener('DOMContentLoaded', function () {
      ensureVideoModal();
      renderVideo();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
